/* HALEYRA v8 — PDP conversion layer: pack tiers, free-gift add, dispatch countdown, scarcity timer. */
(function () {
  if (window.__hlPdp) return;
  window.__hlPdp = true;

  /* ---------- Pack tiers ---------- */
  function initTiers(root) {
    var sectionId = root.getAttribute('data-section');
    var giftVariant = root.getAttribute('data-gift-variant');
    var section = document.getElementById('MainProduct-' + sectionId) || document;

    function syncDawn(value) {
      // Click the hidden Dawn pill input for the Pack option so Dawn updates price / URL / id.
      var inputs = section.querySelectorAll('.hl-option--pack input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) {
          if (!inputs[i].checked) {
            inputs[i].checked = true;
            inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }
      // Fallback: no Dawn picker in DOM -> set the hidden id input directly.
      var idInput = section.querySelector('product-form form input[name="id"]');
      var sel = root.querySelector('.hl-tier__input:checked');
      if (idInput && sel) idInput.value = sel.getAttribute('data-variant-id');
      return false;
    }

    function paint() {
      var sel = root.querySelector('.hl-tier__input:checked');
      root.querySelectorAll('.hl-tier').forEach(function (t) {
        t.classList.toggle('is-selected', t.querySelector('.hl-tier__input').checked);
      });
      if (!sel) return;
      // ATC "Save $x" sub-line
      var saveEl = section.querySelector('.hl-atc-save');
      var save = sel.getAttribute('data-save');
      if (saveEl) {
        saveEl.textContent = save ? 'Save ' + save : '';
        saveEl.style.display = save ? '' : 'none';
      }
      // Sticky bar price
      var sticky = document.querySelector('#HlStickyPrice-' + sectionId);
      if (sticky) sticky.textContent = sel.getAttribute('data-price');
      root.setAttribute('data-gift-active', sel.getAttribute('data-gift') === '1' && giftVariant ? '1' : '0');
    }

    root.addEventListener('change', function (e) {
      if (!e.target.classList.contains('hl-tier__input')) return;
      syncDawn(e.target.value);
      paint();
    });

    // Keep tiers in sync if Dawn's own (hidden) picker changes (e.g. URL ?variant=)
    section.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('.hl-option--pack')) return;
      var val = e.target.value;
      root.querySelectorAll('.hl-tier__input').forEach(function (i) {
        i.checked = i.value === val;
      });
      paint();
    });

    // Free gift: add it right before Dawn submits the main product.
    var form = section.querySelector('product-form form[action*="/cart/add"]') || section.querySelector('form[action*="/cart/add"]:not([id*="installment"])');
    if (form && giftVariant) {
      form.addEventListener(
        'submit',
        function (e) {
          if (form.__hlGiftDone || root.getAttribute('data-gift-active') !== '1') return;
          e.preventDefault();
          e.stopImmediatePropagation();
          var body = JSON.stringify({ items: [{ id: Number(giftVariant), quantity: 1, properties: { _gift: 'Free gift' } }] });
          fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: body,
          })
            .catch(function () {})
            .then(function () {
              form.__hlGiftDone = true;
              if (form.requestSubmit) form.requestSubmit();
              else form.submit();
              setTimeout(function () {
                form.__hlGiftDone = false;
              }, 1500);
            });
        },
        true
      );
    }

    paint();
  }

  /* ---------- Dispatch countdown (cutoff in America/New_York) ---------- */
  function initShip(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff') || '14', 10);
    var before = el.getAttribute('data-before') || 'Order within [time] for same-day dispatch';
    var after = el.getAttribute('data-after') || 'Ships next business day';
    var line = el.querySelector('[data-hl-ship-line]');
    if (!line) return;

    function nyParts() {
      var f = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        hour12: false,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      });
      var o = {};
      f.formatToParts(new Date()).forEach(function (p) {
        o[p.type] = p.value;
      });
      return { wd: o.weekday, h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10), s: parseInt(o.second, 10) };
    }
    function tick() {
      var t = nyParts();
      var weekend = t.wd === 'Sat' || t.wd === 'Sun';
      var secsLeft = (cutoff - t.h) * 3600 - t.m * 60 - t.s;
      if (!weekend && secsLeft > 0) {
        var h = Math.floor(secsLeft / 3600),
          m = Math.floor((secsLeft % 3600) / 60);
        var str = (h > 0 ? h + 'h ' : '') + m + 'm';
        line.textContent = before.replace('[time]', str);
        el.classList.add('is-live');
      } else {
        line.textContent = after;
        el.classList.remove('is-live');
      }
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- Scarcity: countdown to local midnight ---------- */
  function initScarcity(el) {
    var t = el.querySelector('[data-hl-timer]');
    if (!t) return;
    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      t.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('hl-tiers').forEach(initTiers);
    document.querySelectorAll('[data-hl-ship]').forEach(initShip);
    document.querySelectorAll('[data-hl-scarcity]').forEach(initScarcity);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
